import React,{useState,useEffect} from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import './index.css'
import Table from './shippingTable'

const Index = () => {
    const [list,setList] = useState([]);
  return (
    <div className='labadmin_shipping_container'>
        <Title Value={'Shipping'}/>
        <Table List={list}/>
    </div>
  )
}

export default Index
